import {
  ADD_PAYMENT_REQUEST,
  GET_ALL_PAYMENTS_REQUEST,
  GET_CUSTOMER_PAYMENTS_REQUEST,
  GET_PAYMENTS_GRAPH_REQUEST,
  GET_PENDING_PAYMENTS_REQUEST,
  GET_TOTAL_PAYMENTS_REQUEST,
} from './actionTypes';

export const getPaymentsByCustomer = customerId => ({
  type: GET_CUSTOMER_PAYMENTS_REQUEST,
  customerId,
});

export const addPayment = (
  customerId,
  note,
  cardValidityFrom,
  cardValidityTo,
  months,
) => ({
  type: ADD_PAYMENT_REQUEST,
  payload: {
    customerId,
    note,
    cardValidityFrom,
    cardValidityTo,
    months,
  },
  customerId,
});

export const getAllPayments = (filters = {}) => ({
  type: GET_ALL_PAYMENTS_REQUEST,
  filters,
});

export const getTotalPayments = (filters = {}) => ({
  type: GET_TOTAL_PAYMENTS_REQUEST,
  filters,
});

export const getPaymentsGraph = () => ({
  type: GET_PAYMENTS_GRAPH_REQUEST,
});

export const getPendingPayments = (filters = {}) => ({
  type: GET_PENDING_PAYMENTS_REQUEST,
  filters,
});
